import { useScrollReveal } from '../../hooks/useScrollReveal';

export interface AiFeature {
  icon: string;
  title: string;
  desc: string;
}

export interface AiAnswerProps {
  label?: string;
  title: string;
  body: string;
  bodyExtra?: string;
  features: AiFeature[];
}

export default function PageAiAnswer({
  label = 'About Our Services',
  title,
  body,
  bodyExtra,
  features,
}: AiAnswerProps) {
  const ref = useScrollReveal<HTMLDivElement>();

  return (
    <section className="bg-white py-28">
      <div className="max-w-5xl mx-auto px-6">
        <div ref={ref} className="section-reveal">
          <div className="border-l-4 border-gold pl-8">
            <span className="text-gold text-xs tracking-widest uppercase font-semibold">{label}</span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-neutral-900 mt-3 mb-6 leading-tight">
              {title}
            </h2>
            <p className="text-neutral-600 text-lg leading-relaxed mb-4"
               dangerouslySetInnerHTML={{ __html: body }}
            />
            {bodyExtra && (
              <p className="text-neutral-500 leading-relaxed text-sm"
                 dangerouslySetInnerHTML={{ __html: bodyExtra }}
              />
            )}
          </div>

          <div className="mt-14 grid sm:grid-cols-3 gap-6">
            {features.map((feat) => (
              <div key={feat.title} className="flex flex-col items-center text-center p-7 border border-neutral-100 hover:border-gold/40 transition-colors duration-300 group">
                <div className="w-12 h-12 flex items-center justify-center bg-gold/10 group-hover:bg-gold/20 transition-colors mb-4">
                  <i className={`${feat.icon} text-gold text-xl`}></i>
                </div>
                <h4 className="font-semibold text-neutral-900 text-sm mb-2">{feat.title}</h4>
                <p className="text-neutral-500 text-xs leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex gap-4">
            <a
              href="#contact"
              className="bg-neutral-900 hover:bg-gold transition-colors text-white hover:text-black font-bold px-8 py-4 text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer"
            >
              Book Your Ride
            </a>
            <a
              href="tel:+18436422440"
              className="flex items-center gap-2 border-2 border-neutral-200 hover:border-gold text-neutral-700 hover:text-gold transition-colors font-semibold px-8 py-4 text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-sm"></i></div>
              (843) 642-2440
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
